import { selectHasUpsellOffer, selectLanguage } from 'root-redux/selects/common'
import {
  selectGeneralSubscriptionTrialPeriod,
  selectIsUpgradePassed,
  selectUserStatus,
} from 'root-redux/selects/user'

import { useBulkSelector } from 'hooks/common/useBulkSelector'

import { Language, TrialPeriod } from 'root-constants/common'

const UPSELL_LOCALES = [
  Language.EN,
  Language.ES,
  Language.DE,
  Language.FR,
  Language.PT,
  Language.IT,
  Language.AR,
  Language.TR,
]

const useSelectors = () =>
  useBulkSelector({
    userStatus: selectUserStatus,
    isUpgradePassed: selectIsUpgradePassed,
    language: selectLanguage,
    hasUpsellOffer: selectHasUpsellOffer,
    userTrialPeriod: selectGeneralSubscriptionTrialPeriod,
  })

export const useUpsellStatus = () => {
  const {
    userStatus,
    isUpgradePassed,
    language,
    hasUpsellOffer,
    userTrialPeriod,
  } = useSelectors()

  const isExistingUser = !!userStatus?.config.targetUuid

  return (
    userStatus?.hasSubscription &&
    hasUpsellOffer &&
    userStatus.upsell.isUpsellAvailable &&
    !userStatus.upsell.isUpsellPurchased &&
    !isUpgradePassed &&
    UPSELL_LOCALES.includes(language) &&
    userTrialPeriod !== TrialPeriod.ONE_YEAR &&
    !isExistingUser
  )
}
